import { encryptData, decryptData } from "./encDecData";

// Store data in local storage and session storage for persistence across sessions
export const saveUserDataInSession = (user: any): void => {
  const userData = encryptData(user);
  try {
    localStorage.setItem("userSessionData", JSON.stringify(userData));
    sessionStorage.setItem("userSessionData", JSON.stringify(userData));
  } catch (error) {
    // console.log(error);
  }
};

// Retrieve data from local storage (or fallback to session storage)
export const loadUserDataFromSession = (): any | false => {
  if (typeof window === "undefined") return false;
  let userEncryptedData = localStorage.getItem("userSessionData");

  if (!userEncryptedData) {
    userEncryptedData = sessionStorage.getItem("userSessionData");
    if (userEncryptedData) {
      try {
        localStorage.setItem("userSessionData", userEncryptedData);
      } catch (error) {
        // console.log(error);
      }
    }
  }

  if (!userEncryptedData) return false;

  return decryptData(userEncryptedData);
};

// Delete user session data from local storage and session storage
export const clearUserSession = (): boolean => {
  const localData = localStorage.getItem("userSessionData");
  const sessionData = sessionStorage.getItem("userSessionData");

  if (!localData && !sessionData) return false;

  localStorage.removeItem("userSessionData");
  sessionStorage.removeItem("userSessionData");
  return true;
};

//
